import { FC } from "react";
import { eobsFilterListingResponse, EOBsFilterProps } from "./types";
import { QueryParamsState } from "src/pages/EOBsListing/types";
import useFetch from "src/hooks/useFetch";
import { APIEndpoints } from "src/types/apiTypes";
import HubInputField from "../inputType";
import { GroupBase, OptionsOrGroups } from "react-select";
import { Controller, useForm } from "react-hook-form";


const EOBsFilter: FC<EOBsFilterProps> = ({
    state,
    dispatch,
    onClearButtonClicked,
    handleSearchWithQueryParam
}): JSX.Element => {

    const { control, handleSubmit, reset } = useForm<QueryParamsState>({
        mode: "all",
        defaultValues: state,
    });
   
    const { data: filterData } = useFetch<eobsFilterListingResponse>(APIEndpoints.EOB_FILTER_LISTING);

   // console.log("EOB_FILTER_LISTING......", filterData)

    const searchForCaseListing = (values: QueryParamsState) => {
        handleSearchWithQueryParam(values)
    };

    const clearFilter = () => {
        onClearButtonClicked()
        reset()
    }

    return (
        <>
            <form onSubmit={handleSubmit(searchForCaseListing)}>
                <div className="row eob-filters g-2">
                    <div className="col-12 col-sm-3">
                        <Controller
                            name="insurance_name"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="insurance_name"
                                    isRequired={true}
                                    isRowBased={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={false}
                                    inputPlaceholder="Insurance ..."
                                    dropdownData={
                                        (filterData &&
                                            filterData.data &&
                                            filterData.data.insurance
                                                .map((cleanName) => ({
                                                    value: cleanName,
                                                    label: cleanName
                                                }))) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />
                    </div>
                    <div className="col-12 col-sm-3">
                        <Controller
                            name="insurance_group"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="insurance_group"
                                    isRequired={true}
                                    isRowBased={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={false}
                                    inputPlaceholder="Office State..."
                                    dropdownData={
                                        (filterData &&
                                            filterData.data &&
                                            filterData.data.office_state
                                                .map((cleanName) => ({
                                                    value: cleanName,
                                                    label: cleanName
                                                }))) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />
                    </div>
                    <div className="col-12 col-sm-3">
                        <Controller
                            name="insurance_state"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="insurance_state"
                                    isRequired={true}
                                    isRowBased={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={false}
                                    inputPlaceholder="Plan State..."
                                    dropdownData={
                                        (filterData &&
                                            filterData.data &&
                                            filterData.data.plan_state
                                                .map((cleanName) => ({
                                                    value: cleanName,
                                                    label: cleanName
                                                }))) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />
                    </div>
                    <div className="col-12 col-sm-3">
                        <Controller
                            name="insurance_type"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="insurance_type"
                                    isRequired={true}
                                    isRowBased={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={false}
                                    inputPlaceholder="Plan Type..."
                                    dropdownData={
                                        (filterData &&
                                            filterData.data &&
                                            filterData.data.plan_type
                                                .map((cleanName) => ({
                                                    value: cleanName,
                                                    label: cleanName
                                                }))) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />
                    </div>
                </div>
                <div className="row eob-filters g-2">
                    <div className="col-12 col-sm-3 ps-col">
                        <Controller
                            name="doctor_taxonomy"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="doctor_taxonomy"
                                    isRequired={true}
                                    isRowBased={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={false}
                                    inputPlaceholder="Speciality..."
                                    dropdownData={
                                        (filterData &&
                                            filterData.data &&
                                            filterData.data.speciality
                                                .map((cleanName) => ({
                                                    value: cleanName.doctor_taxonomy,
                                                    label: cleanName.data,
                                                }))) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />
                    </div>
                    <div className="col-12 col-sm-3 product-col">
                        <Controller
                            name="insurance_mac"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="insurance_mac"
                                    isRequired={true}
                                    isRowBased={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={false}
                                    inputPlaceholder="MAC Jurisdiction..."
                                    dropdownData={
                                        (filterData &&
                                            filterData.data &&
                                            filterData.data.mac_juri
                                                .map((item) => item.replace(/°/g, "").replace(/"/g, "").trim()) // Clean ° and " from each string
                                                .filter((item) => item !== "") // Remove empty items
                                                .map((cleanName) => ({
                                                    value: cleanName,
                                                    label: cleanName,
                                                }))) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />
                    </div>
                    <div className="col-12 col-sm-3">
                        <Controller
                            name="cpt_codes"
                            control={control}
                            defaultValue=""
                            render={({ field, fieldState: { error } }) => (
                                <HubInputField
                                    inputId="cpt_codes"
                                    isRequired={true}
                                    isRowBased={true}
                                    field={field}
                                    error={error}
                                    isDropdown={true}
                                    isSearchable={false}
                                    inputPlaceholder="CPT Code(s)..."
                                    dropdownData={
                                        (filterData &&
                                            filterData.data &&
                                            filterData.data.cpt_codes
                                                .map((item) => item.replace(/°/g, "").replace(/"/g, "").trim()) // Clean ° and " from each string
                                                .filter((item) => item !== "") // Remove empty items
                                                .map((cleanName) => ({
                                                    value: cleanName,
                                                    label: cleanName,
                                                }))) as unknown as OptionsOrGroups<string, GroupBase<string>>
                                    }
                                />
                            )}
                        />
                    </div>
                    <div className="col-12 col-sm-1">
                        <button type="button" onClick={() => clearFilter()} className="btn btn-outline-secondary w-100">
                            Clear
                        </button>
                    </div>
                    <div className="col-12 col-sm-2">
                        <button type="submit"
                            className="btn btn-blue w-100">
                            <i className="fas fa-search"></i> Find
                        </button>
                    </div>

                </div>


            </form>
        </>

    );
};

export default EOBsFilter;
